import React from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { aiToggleContainerStyles, aiEmojiGlowStyles, aiGradientTextStyles, aiSwitchStyles } from '../../styles/aiStyles';
import { AI_COLORS } from '../../styles/aiTheme';

interface AIDispositionToggleProps {
    isEnabled: boolean;
    isChecked: boolean;
    onChange: (checked: boolean) => void;
}

const AIDispositionToggle: React.FC<AIDispositionToggleProps> = ({
    isEnabled,
    isChecked,
    onChange
}) => {
    if (!isEnabled) return null;

    return (
        <Box sx={aiToggleContainerStyles}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={aiEmojiGlowStyles}>
                    🤖
                </Typography>
                <Box>
                    <Typography sx={aiGradientTextStyles}>
                        AI-Powered Disposition ✨
                    </Typography>
                    <Typography sx={{
                        fontSize: '12px',
                        color: AI_COLORS.text.tertiary,
                        fontWeight: 500
                    }}>
                         By CollectEdge Intelligence
                    </Typography>
                </Box>
            </Box>
            <Switch
                checked={isChecked}
                onChange={e => onChange(e.target.checked)}
                size="medium"
                sx={aiSwitchStyles}
            />
        </Box>
    );
};

export default AIDispositionToggle;
